// extracted by mini-css-extract-plugin
export default {"logo":"CardCarriersCombined-module__logo___atKrB"};